import React, { useEffect, useState } from 'react'
import { CardFooter, Modal } from 'react-bootstrap'
import { useLocation, useNavigate } from 'react-router-dom'

import {
  BriefcaseBusiness,
  ChevronLeft,
  ChevronRight,
  CircleSmall,
  MoveRight,
  NotebookIcon,
  Play,
  SquareArrowOutUpRightIcon
} from 'lucide-react'
import SearchImg from '../../../Assets/images/flowmsgImg.svg'
import flowQueryImg from '../../../Assets/images/flowQueryimg.png'
import bookIcon from '../../../Assets/images/iconsBooks.svg'
import startImg from '../../../Assets/images/StarImg.png'

import videoImg from '../../../Assets/images/query_image2.png'

import ImagePath from '../../../constants/ImagePath'
import Headings from '../../MainLayout/Headings/Headings'

import Line from '../../MainLayout/Line/Line'

import NotificationModal from '../../../Components/NotificationModal/NotificationModal'
import ActionButtons from '../../../Components/SearchHeader/ActionButton'
import { API_URL, IMG_PATH } from '../../../server'
import Footer from '../../MainLayout/Footer/Footer'
import MobileFooter from '../../MainLayout/Footer/MobileFooter'

import './subjectDetails.css'

import WalletModal from '../../MainLayout/Headings/WalletModal'
import '../flow.css'
import Loopsession from '../../Courses/LoopSession/loopsession'
import corsevideo from '../../../Assets/images/corsevideo.svg'
import BotIntegration from '../../../Components/BotIntegration/BotIntegration'

const FlowSubjectDetails = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const subject = location?.state?.subject || ''

  const [notificationModal, setNotificationModal] = useState(false)
  const [showWalletModal, setShowWalletModal] = useState(false)
  const [isMobile, setIsMobile] = useState(false)
  const [data, setdata] = useState(0)
  const [searchQuery, setSearchQuery] = useState('')
  const [enquiryModal, setEnquiryModal] = useState(false)
  const [courseDetails, setCourseDetails] = useState([])
  const [isloading, setIsloading] = useState(false)
  const [courseModal, setCourseModal] = useState(false)
  const [articalModal, setArticalModal] = useState(false)
  const [articals, setArticals] = useState([])
  const [filteredArticles, setFilteredArticles] = useState([])
  const [subjects, setSubjects] = useState({})

  const [selectedSubject, setSelectedSubject] = useState(subject)
  const [subCategories, setSubCategories] = useState([])
  const [groupedCategories, setGroupedCategories] = useState({})

  //Ai chat boat
  const [isChatOpen, setIsChatOpen] = useState(false)
  const [botId, setBotId] = useState('defaultBotId')
  const [botProfiles, setBotProfiles] = useState([]) // Store bot profiles
  const [botLoading, setBotLoading] = useState(true)
  const user_id = sessionStorage.getItem('user_id')

  const registerid = sessionStorage.getItem('registerid')
  const token = sessionStorage.getItem('token')


  //related to course loop
  const [sessionloop, setSessionloop] = useState(false)
  const [loopSession, setLoopSession] = useState(null)
  const [courseId, setCourseId] = useState('')

  const [guideData, setGuideData] = useState(null)

  useEffect(() => {
    const subjectName = sessionStorage.getItem('subjectName')
    if (subjectName) {
      setSelectedSubject(subjectName)
    }
  }, [])

  useEffect(() => {
    if (selectedSubject !== 'Choose the Subject' && articals.length > 0) {
      const filtered = articals.filter(
        article =>
          article.articleSubject?.toLowerCase() ===
          selectedSubject.toLowerCase()
      )
      setFilteredArticles(filtered)
    } else {
      setFilteredArticles(articals) // Show all articles if no subject selected
    }
  }, [selectedSubject, articals])

  useEffect(() => {
    getAllCourse()
    getAllArticals()
    allSubjects()
  }, [])

  //openSupportModal
  const openSupportModal = () => {
    if (registerid === null) {
      setEnquiryModal(true)
    } else {
      setEnquiryModal(true)
    }
  }

  const openSupportClose = () => {
    setEnquiryModal(false)
  }

  //Articla Modal

  //openSupportModal
  const openArticalModal = () => {
    if (registerid === null) {
      setArticalModal(true)
    } else {
      setArticalModal(true)
    }
  }

  const CloseArticalModal = () => {
    setArticalModal(false)
  }

  //openNotificationModal
  const openNotificationModal = () => {
    if (registerid === null) {
      navigate('/', {
        state: true
      })
    } else {
      setNotificationModal(true)
    }
  }

  const closeNotificationModal = () => {
    getnotificationCount()
    setNotificationModal(false)
  }

  //handleNavigateToWallet
  const handleNavigateToWallet = () => {
    const registerid = sessionStorage.getItem('registerid')
    if (registerid === null) {
      navigate('/', {
        state: true
      })
    } else {
      // navigate('/SettingsMainScreen/SettingWallet', { state: 6 });
      setShowWalletModal(true)
    }
  }

  const handleChatIconClick = () => {
    if (botLoading) {
      console.log('Bot profiles still loading...')
      return
    }

    if (!botId) {
      console.error('No valid bot ID available')
      alert('Chat feature is currently unavailable. Please try again later.')
      return
    }

    console.log('Opening chat with bot ID:', botId)
    setIsChatOpen(prev => !prev)
  }

  const getnotificationCount = async () => {
    const registerid = sessionStorage.getItem('registerid')
    const token = sessionStorage.getItem('token')
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + token)

    const raw = JSON.stringify({
      user_id: registerid
    })

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(API_URL + 'getNotificationCount', requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log(result)
        if (result.status == true) {
          setdata(result.count)
        }
      })
      .catch(error => console.error(error))
  }

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 750) // Bootstrap's lg breakpoint (≤ 992px)
    }

    handleResize() // Check on load
    window.addEventListener('resize', handleResize) // Listen for resize

    return () => window.removeEventListener('resize', handleResize) // Cleanup
  }, [])

  const navigateTo = () => navigate('/SettingContentSupport')

  const [loopSubject, setLoopSubject] = useState('')

  // const navigateToCourse = () => {
  //   if (registerid === null) {
  //     navigate("/", { state: true });
  //   } else {
  //     const firstCourseObj = filteredCourses?.[0] || null; // course object
  //     const firstSession = firstCourseObj?.course?.[0] || null; // first session

  //     if (firstSession && firstSession.loopSession?.length > 0) {
  //       setLoopSession(firstSession.loopSession); // sessions for modal
  //       setCourseId(firstCourseObj._id); // course ID

  //       const subject = firstCourseObj.mySubject?.[0] || "Choose the Subject";
  //       setLoopSubject(subject); // ✅ course subject

  //       // filter articles for this subject
  //       const subjectArticles = articals.filter(
  //         (article) =>
  //           article.articleSubject?.toLowerCase() === subject.toLowerCase()
  //       );

  //       //Key tools
  //       const subjectKeytools = subjects?.subject_tool || [];

  //       console.log("Course ID:", firstCourseObj._id);
  //       console.log("Loop Subject:", subject);
  //       console.log("Subject Articles:", subjectArticles);
  //       console.log("Keytools:", subjectKeytools);
  //       // keep them in state so you can pass down
  //       setFilteredArticles(subjectArticles);

  //       setSessionloop(true);
  //     }
  //   }
  // };

  // const navigateToCourse = () => {
  //   if (registerid === null) {
  //     navigate('/', { state: true })
  //   } else {
  //     const firstCourse = filteredCourses?.[0]?.course?.[0] || null

  //     if (firstCourse && firstCourse.loopSession?.length > 0) {
  //       setLoopSession(firstCourse.loopSession)
  //       setCourseId(firstCourse._id)
  //       console.log('Course ID:', firstCourse._id)
  //       setSessionloop(true)
  //     }
  //   }
  // }
  // const navigateToIndustry = () => navigate('/Industry')

  // Fetch bot profiles on component mount
  useEffect(() => {
    const fetchBotProfiles = async () => {
      try {
        setBotLoading(true)
        const requestOptions = {
          method: 'GET',
          redirect: 'follow'
        }

        const response = await fetch(
          'https://learnatrecess.com:7001/getAllBotProfileLite',
          requestOptions
        )
        const result = await response.json()

        console.log('Bot profiles API response:', result) // Debug log

        if (result && result.Status === true && Array.isArray(result.data)) {
          setBotProfiles(result.data)

          // Use the actual bot_id from the first bot in the response
          if (result.data.length > 0 && result.data[0].bot_id) {
            setBotId(result.data[0].bot_id)
            console.log('✅ Valid bot ID set:', result.data[0].bot_id)
          } else {
            console.error('No valid bot_id found in response')
          }
        } else {
          console.error('Invalid bot profiles response:', result)
        }
      } catch (error) {
        console.error('Error fetching bot profiles:', error)
      } finally {
        setBotLoading(false)
      }
    }

    fetchBotProfiles()
  }, [])

  const getAllCourse = () => {
    setIsloading(true)
    const myHeaders = new Headers()
    myHeaders.append('Content-Type', 'application/json')
    myHeaders.append('Authorization', 'Bearer ' + token)
    const raw = JSON.stringify({
      user_id: registerid
    })

    const requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    }

    fetch(API_URL + 'getAllCourse', requestOptions)
      .then(response => response.json())
      .then(result => {
        if (result.Status == true) {
          console.log('flowgetAllCourse', result)
          setCourseDetails(result.data.courses)
          setIsloading(false)
        }
      })
      .catch(error => {
        console.error(error)
        setIsloading(false)
      })
  }

  // const getAllArticals = () => {
  //   const requestOptions = {
  //     method: 'GET',
  //     redirect: 'follow'
  //   }

  //   fetch(API_URL + 'getAllArticles', requestOptions)
  //     .then(response => response.json())
  //     .then(result => {
  //       console.log('getAllArticles', result)
  //       setArticals(result.data)
  //     })
  //     .catch(error => console.error(error))
  // }
  const getAllArticals = () => {
    const requestOptions = {
      method: 'GET',
      redirect: 'follow'
    }

    fetch(API_URL + 'getAllArticles', requestOptions)
      .then(response => response.json())
      .then(result => {
        console.log('getAllArticles', result)
        setArticals(result.data)
        setFilteredArticles(result.data)
      })
      .catch(error => console.error(error))
  }

  const handleSelectSubject = () => {
    setCourseModal(true)
  }

  const CloseCourseModal = () => {
    setCourseModal(false)
  }

  const getexpertsbysubject = subject => {
    navigate('/HomeScreen', { state: { selectedSubject: subject } })
  }

  const getcoursesbysubject = subject => {
    navigate('/CardCourses', { state: { selectedSubject: subject } })
  }

  const navigateToIndustry = subject => {
    navigate('/Industry', { state: { selectedSubject: subject } })
  }

  const formatUrl = url => {
    return url.startsWith('http') ? url : `https://${url}`
  }

  useEffect(() => {
    const removeDuplicates = data => {
      const uniqueSubCategories = []
      const seen = new Set()

      data.forEach(subCategory => {
        const uniqueKey = `${subCategory.categoryText}-${subCategory.subject}`
        if (!seen.has(uniqueKey)) {
          seen.add(uniqueKey)
          uniqueSubCategories.push(subCategory)
        }
      })

      return uniqueSubCategories
    }

    const groupByCategory = data => {
      return data.reduce((acc, subCategory) => {
        const { categoryText } = subCategory
        if (!acc[categoryText]) {
          acc[categoryText] = []
        }
        acc[categoryText].push(subCategory)
        return acc
      }, {})
    }

    const uniqueSubCategories = removeDuplicates(subCategories)
    setGroupedCategories(groupByCategory(uniqueSubCategories))
  }, [subCategories])

  useEffect(() => {
    const fetchSubCategories = async () => {
      const requestOptions = {
        method: 'POST',
        redirect: 'follow'
      }

      try {
        const response = await fetch(
          API_URL + 'getAllSubCategory',
          requestOptions
        )
        const result = await response.json()
        setSubCategories(result.data)
      } catch (error) {
        console.error(error)
      }
    }

    fetchSubCategories()
  }, [])

  // const filteredCourses = courseDetails.filter(course =>
  //   course.mySubject?.some(subject =>
  //     subject.toLowerCase().includes(selectedSubject.toLowerCase())
  //   )
  // )

  // const safeSelectedSubject = String(selectedSubject || "")
  //   .toLowerCase()
  //   .trim();

  // const filteredCourses = courseDetails.filter((course) => {
  //   if (!course.mySubject || !safeSelectedSubject) return false;

  //   return course.mySubject.some((subject) => {
  //     const subjectStr = String(subject || "")
  //       .toLowerCase()
  //       .trim();
  //     return subjectStr.includes(safeSelectedSubject);
  //   });
  // });

  // ✅ Safely normalize selected subject
  const safeSelectedSubject = String(selectedSubject || '')
    .toLowerCase()
    .trim()

  // ✅ Always make sure courseDetails is an array before filtering
  const filteredCourses = (
    Array.isArray(courseDetails) ? courseDetails : []
  ).filter(course => {
    if (!course?.mySubject || !safeSelectedSubject) return false

    return course.mySubject.some(subject => {
      const subjectStr = String(subject || '')
        .toLowerCase()
        .trim()
      return subjectStr.includes(safeSelectedSubject)
    })
  })

  useEffect(() => {
    if (subject) {
      setSelectedSubject(subject) // keep your data consistent
    }
  }, [subject])

  const handleSelectedSubject = subjectName => {
    sessionStorage.setItem('subjectName', subjectName)
    setSelectedSubject(subjectName)
  }
  const currentSubject =
    location.state?.subject ||
    sessionStorage.getItem('subjectName') ||
    'Choose the Subject'

  // const onSetAsLearningPath = () => {
  //   handleSelectedSubject(currentSubject)
  //   navigate('/')
  // }

  const onSetAsLearningPath = async () => {
    const registerid = sessionStorage.getItem('registerid')
    const token = sessionStorage.getItem('token')

    if (!registerid || !token) {
      navigate('/', { state: true })
      return
    }

    try {
      const response = await fetch(
        'https://learnatrecess.com:7001/bookSubjectForUser',
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            user_id: registerid,
            subject: currentSubject
          })
        }
      )

      const result = await response.json()
      console.log('Set learning path response:', result)

      // Optional UX boost
      sessionStorage.setItem('subjectName', currentSubject)

      // ✅ Go back to Flow (learning path page)
      navigate('/')
    } catch (error) {
      console.error('Error setting learning path:', error)
    }
  }

  const allSubjects = () => {
    
    // If token is available, use existing API
    if (token) {
      const myHeaders = new Headers()
      myHeaders.append('Authorization', 'Bearer ' + token)
      const raw = ''

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        redirect: 'follow'
      }

      fetch(API_URL + 'getAllSubject', requestOptions)
        .then(response => response.json())
        .then(result => {
          
          const subjects = result.data.filter(item => item.subject == subject)
          console.log('getAllSubject result After Login:', subjects);

          setSubjects(subjects[0])
        })
        .catch(error => console.error('❌ getAllSubject API Error:', error))
    } else {
      if (!subject) {
        console.warn('❌ No subject name available')
        return
      }

  

      const myHeaders = new Headers()
      myHeaders.append('Content-Type', 'application/json')

      const raw = JSON.stringify({
        subject: subject
      })

      const requestOptions = {
        method: 'POST',
        headers: myHeaders,
        body: raw,
        redirect: 'follow'
      }

      fetch('https://learnatrecess.com:7001/getAllSubject1', requestOptions)
        .then(response => response.json())
        .then(result => {
          if (result.Status === true && result.data) {
            console.log('getAllSubject1 result before login:', result);
            setSubjects(result.data) 
          } else {
            console.error('❌ getAllSubject1 Failed - Status:', result.Status)
          }
        })
        .catch(error => console.error('❌ getAllSubject1 API Error:', error))
    }
  }

  const loadGuide = async subjectName => {
    const subject = await allSubjects(subjectName)
    setGuideData(subject)
  }

  useEffect(() => {
    if (selectedSubject) {
      loadGuide(selectedSubject)
    }
  }, [selectedSubject])

  return (
    <div className='flow-page-wrapper min-h-screen bg-[#F5F3EE] flex flex-col w-m-xxl-auto '>
      <div className='w-full'>
        <NotificationModal
          show={notificationModal}
          handleClose={closeNotificationModal}
        />
        <Headings screenHeadingName='recess.' />

        <main className='flex-1 mx-auto py-2 px-4 min-[600px]:px-2'>
          <div className='flex flex-col md:flex-row md:items-center md:justify-start gap-1  w-full'>
            <div className='flex flex-col md:flex-row md:items-center gap-2 flex-1 mb-2'>
              {/* Search Field */}
              <div className='relative lg:w-96 w-full'>
                <input
                  type='text'
                  placeholder='Ask a question'
                  // value={searchQuery}
                  // onChange={e => setSearchQuery(e.target.value)}
                  value=''
                  readOnly
                  tabIndex={-1} // ❌ prevents focus
                  onMouseDown={e => e.preventDefault()} // ❌ prevents cursor
                  onClick={handleChatIconClick}
                  className='serachfield w-full bg-[#EAEAEA] rounded-md placeholder:text-[#5B5B5B] pl-10 py-2 border border-transparent focus:outline-none focus:border-gray-400'
                />
                <img
                  className='absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400 size-5'
                  src={SearchImg}
                />
              </div>
            </div>

            {/* place at end Right Side this one show  for  tab and desktop responsive */}
            <div className='hidden md:flex items-center justify-end gap-2'>
              <ActionButtons
                onSupportClick={openSupportModal}
                onNotificationClick={openNotificationModal}
                onWalletClick={handleNavigateToWallet}
                notificationCount={data}
              />
            </div>
          </div>

          <div className='w-full mt-2'>
            {' '}
            <Line />
          </div>

          <div class='flex flex-col lg:flex-row gap-16 px-2 py-8  min-h-screen font-sans '>
            {/* Left Container */}
            <div class='w-full lg:w-1/3 '>
              <h2 class='text-2xl font-recoleta mb-2 leading-tight'>
                {subject ? subject : 'Product Design'}
              </h2>

              {subjects.description && (
                <p className='text-black mb-0 text-sm font-avenir font-semibold mt-3'>
                  {subjects.description}
                </p>
              )}
              {/* {subjects?.description ? (
                <p className='text-black mb-0 text-sm font-avenir font-semibold mt-3'>
                  {subjects.description}
                </p>
              ) : (
                <p className='text-black mb-0 text-sm font-avenir font-semibold mt-3'>
                  No description available for this subject.
                </p>
              )} */}

              <div className='w-full mt-3 mb-3'>
                <Line />
              </div>

              <div
                onClick={onSetAsLearningPath}
                className='border border-black p-3 rounded-lg bg-black hover:shadow-md cursor-pointer'
              >
                <div className='flex items-start gap-2 justify-between'>
                  <div>
                    <p className='font-normal font-avenir text-white'>
                      <img
                        src={startImg}
                        alt='Tutor'
                        className='w-6 h-7 mr-2 inline'
                      />
                      Set as Learning Path
                    </p>
                  </div>
                  <ChevronRight className='text-white' />{' '}
                  {/* Make arrow white */}
                </div>
              </div>

              <div className='w-full mt-3 mb-3'>
                <Line />
              </div>

              {/* <h3 class="text-base font-recoleta  mb-4">Key Tools</h3>

              {subjects?.subject_tool?.length > 0 &&
                subjects.subject_tool.map((item, index) => (
                  <div key={index} className="space-y-4">
                    <div className="border border-[#D0D0D0] p-2 mb-2 rounded-lg bg-white hover:shadow-md">
                      <div className="flex items-start gap-2">
                        <img
                          src={
                            item.image ? `${IMG_PATH}${item.image}` : bookIcon
                          }
                          alt="Tutor"
                          className="w-10 h-10 mr-2 inline"
                        />
                        <div>
                          <p className="font-semibold items-center mb-1">
                            {item.toolName}{" "}
                            <SquareArrowOutUpRightIcon className="inline text-black mt-1 w-3 h-3" />
                          </p>
                          <p className="text-xs text-black font-semibold">
                            {item.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))} */}
              <h3 className='text-base font-recoleta mb-4'>Key Tools</h3>

              {subjects?.subject_tool?.length > 0 &&
                subjects.subject_tool.map((item, index) => (
                  <div
                    key={index}
                    onClick={() => {
                      if (item.subjectUrl) {
                        window.open(item.subjectUrl, '_blank') // 👈 Opens in new tab
                      }
                    }}
                    className='space-y-4 cursor-pointer transition-transform hover:scale-[1.01]'
                  >
                    <div className='border border-[#D0D0D0] p-2 mb-2 rounded-lg bg-white hover:shadow-md'>
                      <div className='flex items-center gap-2'>
                        <img
                          src={
                            item.image ? `${IMG_PATH}${item.image}` : bookIcon
                          }
                          alt={item.toolName || 'Tool'}
                          className='w-10 h-10 mr-2 inline  rounded-[8px]'
                        />
                        <div className='flex flex-col justify-center flex-1 mb-2'>
                          <p className='font-semibold items-center mb-1 mt-2'>
                            {item.toolName}{' '}
                            {item.subjectUrl && (
                              <SquareArrowOutUpRightIcon className='inline text-black mt-1 w-3 h-3' />
                            )}
                          </p>
                          <p className='text-xs text-black font-semibold mb-1'>
                            {item.description}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}

              <div className='w-full mt-3 mb-3'>
                <Line />
              </div>

              <div
                onClick={() => navigate(-1)}
                className='border border-[#D0D0D0] py-2.5 px-2  rounded-2 mt-2 cursor-pointer d-inline-block w-full'
              >
                <ChevronLeft className='inline mr-2' />
                Back
              </div>
            </div>

            {/* Right Container */}
            <div class='flow-right-container w-full flex flex-col gap-4 lg:max-w-[504px]'>
              {/* Video Thumbnail */}
              {subjects?.subject_vedio ? (
                <div className='relative w-full aspect-video rounded-xl overflow-hidden shadow-custom'>
                  <video
                    src={`${IMG_PATH}${subjects.subject_vedio}`}
                    className='w-full h-full object-cover'
                    controls
                  />
                </div>
              ) : (
                <div className='relative w-full aspect-video rounded-xl overflow-hidden shadow-custom'>
                  <img
                    src={videoImg}
                    alt='subject'
                    className='w-full h-full object-cover'
                  />
                  <div className='absolute inset-0 flex items-center justify-center'>
                    <Play className='h-10 w-10 text-white' />
                  </div>
                </div>
              )}

              {/* Header text */}
              {/* <div className='flex justify-between '>
                <h3 class='text-2xl font-recoleta mt-2'>
                  Learn Product Design
                </h3>
              </div> */}

              <div className='flex justify-between'>
                <h3 className='text-2xl font-recoleta mt-2'>
                  Learn {selectedSubject || subjects?.subject || 'Subject'}
                </h3>
              </div>

              {/* Card 1 */}
              <div
                // onClick={navigateToCourse}
                // onClick={() => getcoursesbysubject(selectedSubject)}
                className='bg-[#DFE9F4] border rounded-xl p-4 flex justify-between items-start hover:bg-[#FDFCFB] cursor-pointer'
                style={{ boxShadow: '-8px 8px 10px rgba(0, 0, 0, 0.13)' }}
              >
                {filteredCourses.length > 0 ? (
                  // Show first matching course
                  <div>
                    {/* <p class='text-sm text-black font-medium'>
                      {' '}
                      <CircleSmall class='text-black inline w-4 h-4 mr-1' />{' '}
                      Course Loop
                    </p> */}
                    <p className='text-sm text-black font-bold flex items-center'>
                      {' '}
                      <img
                        src={corsevideo}
                        alt='Course Video'
                        className='inline w-4 h-4 mr-1'
                      />
                      Interactive Loops
                    </p>
                    <h3 className='text-2xl font-recoleta mt-4'>
                      {/* {filteredCourses[0].course?.[0]?.loopSession?.[0]
                        ?.TitleName || "Complete a Course"} */}
                      Complete a Course
                    </h3>
                    <p className='text-sm text-black mt-2 font-semibold'>
                      Build your skills in {selectedSubject}.
                    </p>
                  </div>
                ) : (
                  // Show default content when no subject matches
                  <div>
                    <p class='text-sm text-black font-medium'>
                      {' '}
                      <CircleSmall class='text-black inline w-4 h-4 mr-1' />{' '}
                      Interactive Loops
                    </p>
                    <h3 className='text-2xl font-recoleta mt-4'>
                      Complete a Course
                    </h3>
                    <p className='text-sm text-black mt-2 font-semibold'>
                      Build your skills in {selectedSubject}.
                    </p>
                  </div>
                )}

                <MoveRight class='text-black mt-1' />
              </div>

              {/* Card 2 */}
              <div
                // onClick={(e) => {
                //   e.stopPropagation();
                //   getexpertsbysubject(selectedSubject);
                // }}
                class='bg-[#D8E6E3] border rounded-xl p-4 shadow-md flex justify-between items-start hover:bg-[#FDFCFB] cursor-pointer'
                style={{ boxShadow: '-8px 8px 10px rgba(0, 0, 0, 0.13)' }}
              >
                <div>
                  <p class='text-sm text-black font-medium'>
                    <img
                      src={ImagePath.tutors}
                      alt='Tutor'
                      className='w-4 h-4 inline mr-1'
                    />{' '}
                    1:1 Sessions
                  </p>
                  <h3 class='text-2xl font-recoleta mt-4'>Talk to a Tutor</h3>
                  <p class='text-sm  text-black mt-2 font-semibold'>
                    Get answers and advice in {selectedSubject}.
                  </p>
                </div>
                <MoveRight class='text-black mt-1' />
              </div>

              {/* Card 3 */}
              <div
                // onClick={(e) => {
                //   e.stopPropagation();
                //   navigateToIndustry(selectedSubject);
                // }}
                class='bg-[#F2E3D9] border rounded-xl p-4 shadow-md flex justify-between items-start hover:bg-[#FDFCFB]  cursor-pointer'
                style={{ boxShadow: '-8px 8px 10px rgba(0, 0, 0, 0.13)' }}
              >
                <div>
                  <p class='text-sm text-black font-medium'>
                    <BriefcaseBusiness class='text-black inline w-4 h-4 mr-1' />{' '}
                    Projects
                  </p>
                  <h3 class='text-2xl font-recoleta mt-4'>
                    Practice your Skills
                  </h3>
                  <p class='text-sm text-black mt-2 font-semibold'>
                    Work on real-world {selectedSubject} projects.
                  </p>
                </div>
                <MoveRight class='text-black mt-1' />
              </div>

              {/* Card 4 */}
              {subjects?.guide_title ? (
                <div
                  className='bg-[#E9E1EF] border rounded-xl p-4 shadow-md hover:bg-[#FDFCFB] cursor-pointer block'
                  style={{ boxShadow: '-8px 8px 10px rgba(0, 0, 0, 0.13)' }}
                >
                  {/* Top Row */}
                  <div className='flex justify-between items-start'>
                    <p className='text-sm text-black font-medium'>
                      <NotebookIcon className='text-black inline w-4 h-4 mr-1' />{' '}
                      Guide
                    </p>
                    <SquareArrowOutUpRightIcon className='text-black mt-1 w-4 h-4' />
                  </div>

                  {/* Title */}
                  <h4 className='text-2xl font-recoleta mt-2'>
                    {subjects.guide_title}
                  </h4>

                  {/* Description */}
                  <p className='text-sm text-black mt-2 font-semibold line-clamp-2'>
                    {subjects.guide_description}
                  </p>
                </div>
              ) : (
                <div className='text-center py-4'>
                  <p className='text-sm text-gray-500'>
                    {subject !== 'Choose the Subject'
                      ? `No articles found for ${subject}`
                      : 'No articles available'}
                  </p>
                </div>
              )}
            </div>
          </div>
        </main>

        {/* Chatbot modal rendering */}
        {isChatOpen && botId && (
          <BotIntegration
            botId={botId}
            userId={user_id || registerid || `user-${Date.now()}`}
            onClose={() => setIsChatOpen(false)}
          />
        )}

        {/* Step 1:enquiryModal Modal 1 */}
        <Modal
          centered
          show={enquiryModal}
          onHide={openSupportClose}
          className='items-center m-0'
        >
          <div className='modalbackgroundcolor rounded-3'>
            {/* Top Image Section with Close Button */}

            <div className='relative w-full'>
              <img
                src={flowQueryImg}
                alt='query_image1'
                className='w-full px-0 py-0 rounded-t-xl object-cover'
              />

              {/* Top-right image or button */}
              <div className='absolute top-3 right-3'>
                <button
                  type='button'
                  className='btn btn-close color-white bg-white'
                  onClick={openSupportClose}
                ></button>
              </div>
            </div>

            {/* Centered Text Section */}
            <div className='relative p-4 d-flex flex-column justify-content-center align-items-center text-center '>
              <dt className='sortHeading'>How Recess Works</dt>
              <p className='text-muted mb-3 mt-2 fw-medium'>
                Recess is your personalised learning space. Pick a subject,
                follow your learning path, and explore lessons, tools, and
                real-world tasks at your own pace.
              </p>
              <p className='text-muted mb-3 mt-2 fw-medium'>
                Flow, your AI assistant, is always ready to answer questions and
                guide your next steps.
              </p>
              <p className='text-muted mb-3 mt-2 fw-medium'>
                You can also connect with expert tutors anytime for more
                support.
              </p>
              {/* Button */}
              <button
                onClick={() => {
                  openSupportClose() // Close first modal
                }}
                className='w-100 bg-dark text-white rounded-md fw-medium hover:bg-secondary transition py-2'
              >
                Continue
              </button>

              <div className='text-center mt-4'>
                <p className='text-muted fw-medium mb-0'>
                  Need help? You can always{' '}
                  <span
                    className='fw-bold text-black cursor-pointer'
                    onClick={navigateTo}
                  >
                    Contact Support.
                  </span>
                </p>
              </div>
            </div>
          </div>
        </Modal>

        {/* walllet */}
        <WalletModal
          stripmodal={showWalletModal}
          closestripModal={() => setShowWalletModal(false)}
          price={100}
          currency='USD'
        />

        <Modal
          centered
          show={courseModal}
          onHide={CloseCourseModal}
          className='items-center m-0'
        >
          <div className=' modalbackgroundcolor p-4 rounded-3'>
            <div className='xmark'>
              <button
                type='button'
                className='btn btn-close ms-auto'
                onClick={CloseCourseModal}
              ></button>
            </div>
            <dl style={{ marginTop: '50px', marginLeft: '30px' }}>
              <dt className='sortHeading mb-2'>Browse Subjects</dt>
              <p className='text-sm text-black font-[500] font-avenir'>
                Select a subject to view tools, loops, and tasks. Set it as your
                learning path anytime.
              </p>

              <hr className='lines' />
              {Object.keys(groupedCategories).map(category => (
                <React.Fragment key={category}>
                  <dd className='sortname1'>{category}</dd>
                  <hr className='lines' />
                  {groupedCategories[category].map(subCategory => (
                    <React.Fragment key={subCategory._id}>
                      <dd
                        onClick={() => {
                          handleSelectedSubject(subCategory.subject)
                          CloseCourseModal()
                        }}
                        className='sortnames ml-4 mb-3 justify-between '
                      >
                        <label
                          htmlFor={subCategory.subject}
                          style={{ fontSize: '0.9rem' }}
                        >
                          {subCategory.subject}
                        </label>
                        <ChevronRight />
                      </dd>

                      <hr className='lines' />
                    </React.Fragment>
                  ))}
                </React.Fragment>
              ))}
            </dl>
          </div>
        </Modal>
        {/* Articalmodal */}
        {/* <Modal
          centered
          show={articalModal}
          onHide={CloseArticalModal}
          className='items-center m-0'
        >
          <div className='modalbackgroundcolor p-4 rounded-3'>
            <div className='xmark'>
              <button
                type='button'
                className='btn btn-close ms-auto'
                onClick={CloseArticalModal}
              ></button>
            </div>

            <dl style={{ marginTop: '20px' }}>
              <dt className='sortHeading'>Aricals</dt>
              <hr className='lines m-2' />

              {articals.map((artical, index) => (
                <React.Fragment key={index}>
                  <a
                    href={formatUrl(artical.articleUrl)}
                    onClick={CloseArticalModal}
                    className='bg-[#E9E1EF] border rounded-xl p-4 shadow-md flex justify-between items-start hover:bg-pink-100 cursor-pointer'
                    style={{ boxShadow: '-8px 8px 10px rgba(0, 0, 0, 0.13)' }}
                  >
                    <div>
                      <h3 className='text-2xl font-recoleta mt-1'>
                        {artical.articleTitle}
                      </h3>
                      <p className='text-sm text-black mt-2 font-semibold'>
                        {artical.articleDescription}
                      </p>
                    </div>
                    <MoveRight className='text-black mt-1 w-4 h-4' />
                  </a>
                  <hr className='lines mb-2' />
                </React.Fragment>
              ))}
            </dl>
          </div>
        </Modal> */}
      </div>
      {/* Fullscreen Loopsession Modal */}
      <Modal
        show={sessionloop}
        onHide={() => setSessionloop(false)}
        backdrop='static'
        keyboard={false}
        fullscreen
        className='fullscreen-modal flex items-center m-0 rad'
      >
        <Modal.Body className='sessionloop-body'>
          <Loopsession
            closeModal={() => setSessionloop(false)}
            loopSession={loopSession}
            courseId={courseId}
            subject={loopSubject}
            articles={filteredArticles}
            keytools={subjects?.subject_tool || []}
          />
        </Modal.Body>
      </Modal>

      <CardFooter className='mt-auto'>
        <p></p>
        <Line />
        <div>
          {/* <Footer /> */}
          {isMobile ? <MobileFooter /> : <Footer />}
        </div>
      </CardFooter>
    </div>
  )
}

export default FlowSubjectDetails

// {filteredArticles.length > 0 ? (
//               filteredArticles.map((article, index) => (
//                 <a
//                   key={index}
//                   href={formatUrl(article.articleUrl)}
//                   target='_blank'
//                   rel='noopener noreferrer'
//                   className='flow-article-card bg-[#E9E1EF] border rounded-xl p-4 shadow-md hover:bg-[#FDFCFB] cursor-pointer block'
//                   style={{
//                     boxShadow: '-8px 8px 10px rgba(0, 0, 0, 0.13)'
//                   }}
//                 >

//                   <div className='flex justify-between items-start'>
//                     <p className='text-sm text-black font-medium'>
//                       <NotebookIcon className='text-black inline w-4 h-4 mr-1' />{' '}
//                       Guide
//                     </p>
//                     <SquareArrowOutUpRightIcon className='text-black mt-1 w-4 h-4' />
//                   </div>

//                   <h4 className='text-2xl font-recoleta mt-2'>

//                     Your Guide to {selectedSubject} in 2025
//                   </h4>

//                   <p class='text-sm text-black mt-2 font-semibold line-clamp-2'>

//                     An in-depth guide to AI skills,careers, and more.
//                   </p>
//                 </a>
//               ))
//             ) : (
//               <div className='text-center py-4'>
//                 <p className='text-sm text-gray-500'>
//                   {selectedSubject !== 'Choose the Subject'
//                     ? `No articles found for ${selectedSubject}`
//                     : 'No articles available'}
//                 </p>
//               </div>
//             )}
